import React from "react";
import { FaClipboardCheck } from "react-icons/fa";
import { IoMdTime } from "react-icons/io";
import { IoDocumentTextOutline, IoLockClosedOutline } from "react-icons/io5";
import { Link } from "react-router-dom";
import "../../css/items.scss";
import tests from "../../data/tests.json";
import "./tests.scss";

const fallbackData = {
  title: "Tests",
  availableTestsAriaLabel: "Available tests",
  start: "Start",
  locked: "Locked",
  minuteShort: "min",
  questions: "questions",
  items: {},
};

const Tests = ({ data = fallbackData }) => {
  const text = { ...fallbackData, ...data };
  const getTestText = (test) => ({
    ...test,
    ...(text.items?.[test.id] || {}),
  });
  const isEnglishPlacementTest = (test) => test.id === "english-placement";

  return (
    <div className="items-container" id="tests">
      <section className="upper-section">
        <div className="upper-section-inner">
          <div className="title-container">
            <h2>{text.title}</h2>
          </div>
        </div>
      </section>

      <main className="main-container">
        <section className="tests-list" aria-label={text.availableTestsAriaLabel}>
          {tests.map((test) => {
            const testText = getTestText(test);

            return (
            <article
              key={test.id}
              className={`test-card ${test.locked ? "test-card--locked" : ""} ${isEnglishPlacementTest(test) ? "test-card--english-placement" : ""}`}
            >
              {isEnglishPlacementTest(test) ? (
                <img
                  className="test-card__flag-image"
                  src="/images/flags/us.png"
                  alt=""
                  aria-hidden="true"
                />
              ) : null}

              <div className="test-card__icon">
                <FaClipboardCheck size={28} />
              </div>

              <div className="test-card__body">
                <div className="test-card__meta">
                  <span>{testText.category}</span>
                  {testText.statusLabel ? <span className="test-card__flag">{testText.statusLabel}</span> : null}
                </div>
                <h3>{testText.title}</h3>
                <p>{testText.description}</p>

                <div className="test-card__details">
                  <span>
                    <IoMdTime size={18} />
                    {test.durationMinutes} {text.minuteShort}
                  </span>
                  <span>
                    <IoDocumentTextOutline size={18} />
                    {test.questionCount} {text.questions}
                  </span>
                </div>
              </div>

              {test.locked ? (
                <button type="button" className="test-card__action test-card__action--locked" disabled>
                  <IoLockClosedOutline size={17} />
                  {text.locked}
                </button>
              ) : (
                <Link to={`/tests/${test.id}`} className="test-card__action">
                  {text.start}
                </Link>
              )}
            </article>
            );
          })}
        </section>
      </main>
    </div>
  );
};

export default Tests;
